import styled from 'styled-components'
import theme from './theme'

export const Footer = styled.footer`
    height: 80px;
    background-color: ${theme.colors.main};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: white;
    height: 12vh;
`;